import { createApp } from "vue";
import ProductRequestWidget from "./ProductRequestWidget.vue";
import Toast, { POSITION } from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

const app = createApp(ProductRequestWidget);

app.use(Toast, {
  position: POSITION.BOTTOM_CENTER,
  timeout: 6000,
  closeOnClick: true,
  pauseOnHover: true,
});

document.addEventListener("DOMContentLoaded", () => {
  const el = document.getElementById("vue-widget");
  if (el) {
    app.mount("#vue-widget");
  }
});
